import { tr } from "@/i18n";
// Text-only underlined sub-tabs, directly under the page header. tabs: [{ key, label, badge, testId }]
// dense: tighter padding + smaller text so a full tab set fits a half-width (split) pane.
export default function SubTabs({ tabs, active, onChange, testId, className = "", dense = false }) {
  return (
    <div className={`shrink-0 bg-background px-4 ${className}`} data-testid={testId}>
      <div className={`flex items-center border-b border-slate-200 ${dense ? "flex-nowrap gap-0 overflow-x-auto" : "flex-wrap gap-1"}`}>
        {tabs.map((t) => {
          const on = active === t.key;
          return (
            <button key={t.key} type="button" onClick={() => onChange(t.key)} data-testid={t.testId}
              className={`-mb-px inline-flex items-center gap-1.5 whitespace-nowrap border-b-2 transition-colors ${dense ? "px-2 py-2.5 text-xs" : "px-3 py-3 text-sm"} ${
                on ? "border-brand text-brand font-semibold" : "border-transparent text-slate-500 hover:text-slate-800 font-medium"}`}>
              {tr(t.label)}{t.badge || null}
            </button>
          );
        })}
      </div>
    </div>
  );
}
